import $ from 'jquery';
import clipTmpl from './hbs/clip.hbs';

const $clipTmpl = $.templates(clipTmpl);
import {datePager, clipPlayer} from './util';

function episodeClip($wrapper) {
  const $cont = $wrapper.find('.episode_cont');
  const $btn = $cont.find('.wrap_player .thumb');
  const clipData = {};

  $btn.on('click', function () {
    const $this = $(this);
    const $area = $(this).parent();
    const vid = $this.data('id');
    const htmlOutput = $clipTmpl.render(clipData);
    $area.empty();
    $area.html(htmlOutput);
    clipPlayer('nowPlayer', vid);
  });
}

function episodePager(ctx) {
  const $ctx = ctx;

  const $guestCont = $ctx.find('.guest_cont');
  const $guestNav = $guestCont.find('.paging_nav');
  const $guestList = $guestCont.find('.col_size5 li');

  const $placeCont = $ctx.find('.place_cont');
  const $placeNav = $placeCont.find('.paging_nav');
  const $placeList = $placeCont.find('.list_place li');

  const guestPager = new SF.pager({
    navigation: $guestNav,
    list: $guestList,
    viewCount: 5,
    isInfinite: false
  });

  const placePager = new SF.pager({
    navigation: $placeNav,
    list: $placeList,
    viewCount: 2,
    isInfinite: false
  });

}

function episodeDetail(ctx) {
  if (SF.urlParameter.w === 'tot') {
    episodeClip(ctx);
    episodePager(ctx);
  } else {
    episodeClip(ctx);
    datePager(ctx, 7);
  }
}

export default episodeDetail;



/** WEBPACK FOOTER **
 ** ./src/TVP/episode.js
 **/